import alert from '@/plugins/alert'
import { AssetCategory } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    categoryData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    categorySearchParams: {},
    totalItems: 0,
    categories: [],
    categoryTree: []
  },
  actions: {
    async searchCategoryList({ commit, state, dispatch }, query) {
      const categorySearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { categorySearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.categorySearchParams) {
        const categorySearchParams = {
          ...state.categorySearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'level:ASC,code:ASC'
        }

        const [totalItems, categories] = await Promise.all([
          AssetCategory.count(categorySearchParams),
          AssetCategory.search(categorySearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            categories,
            totalItems,
            itemsPerPage,
            categorySearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async fetchCategoryTree({ commit }) {
      try {
        const categoryTree = await AssetCategory.getTree()
        commit('changeState', { categoryTree })
        return categoryTree
      } catch (e) {
        alert.error('Lỗi khi tải cây danh mục')
      }
    },

    async createCategory({ commit, state }, categoryData) {
      try {
        const created = await AssetCategory.create(categoryData)
        commit('changeState', {
          categories: [created, ...state.categories]
        })
        alert.success('Thêm danh mục thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async updateCategory({ commit }, { id, ...categoryData }) {
      try {
        const updated = await AssetCategory.update(id, categoryData)
        commit('updateCategory', updated)
        alert.success('Cập nhật danh mục thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async removeCategory({ commit }, id) {
      try {
        await AssetCategory.remove(id)
        commit('removeCategory', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateCategory(state, categoryData) {
      state.categories = state.categories.map(c => (categoryData.id === c.id ? categoryData : c))
    },
    removeCategory(state, id) {
      state.categories = state.categories.filter(d => d.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  },
  getters: {}
}
